module.exports = __webpack_public_path__ + "img/collaborate.8315fb1b.png";